"use client";

import { User } from "lucide-react";
import Image from "next/image";

interface WeaponDisplayProps {
  imageUrl?: string | null;
  name: string;
}

export function WeaponDisplay({ imageUrl, name }: WeaponDisplayProps) {
  if (imageUrl) {
    return (
      <div className="relative z-10 flex w-4/5 max-w-lg items-center justify-center">
        <Image
          alt={name}
          className="h-auto w-full object-contain drop-shadow-[0_12px_28px_rgba(0,0,0,0.7)]"
          height={400}
          src={imageUrl}
          width={800}
        />
      </div>
    );
  }

  return (
    <div className="relative z-10 flex w-4/5 max-w-lg items-center justify-center rounded-lg border border-[#33383C] bg-[#0C0D0E] p-16">
      <User className="h-24 w-24 text-[#6a7075]" />
    </div>
  );
}
